import { useState } from 'react'
import {
  FilterContainer,
  FilterGroup,
  InvisibleArea,
  FilterGroupLineStyled,
  FilterHeader,
  FilterActions,
  ActionButton,
  ToggleButton,
  ToggleText,
  ToggleIconWrapper,
} from './Filters.styles'
import { Button, Icon, Input, Selector } from '@/components'
import { Calendar, Down, Up } from '@icon-park/react'
import { useReportsContext } from '../../Reports.context'
import { Str } from '@/utils/strings'

export function Filters() {
  const {
    loadingReports,
    applyFilters,
    resetFilters,
    startDateBinder,
    typeBinder,
    monitoringTypeBinder,
    types,
    monitoringTypes,
  } = useReportsContext()
  const toggleAccordion = () => {
    setIsOpen(!isOpen)
  }

  const [isOpen, setIsOpen] = useState(false)

  return (
    <FilterGroup>
      <FilterContainer>
        <FilterHeader>
          Filtros
          <FilterActions>
            <ActionButton onClick={resetFilters}>Limpar Filtros</ActionButton>
            <ToggleButton onClick={toggleAccordion}>
              <ToggleText>{isOpen ? 'Menos' : 'Mais'}</ToggleText>
              <ToggleIconWrapper>
                {isOpen ?
                  <Icon value={Up} color="#01c38d" />
                : <Icon value={Down} color="#01c38d" />}
              </ToggleIconWrapper>
            </ToggleButton>
          </FilterActions>
        </FilterHeader>
        <InvisibleArea $isOpen={isOpen}>
          <FilterGroupLineStyled>
            <Input icon={Calendar} placeholder="Inicio" {...startDateBinder} />
            <Selector.Default
              placeholder="Tipo"
              options={
                monitoringTypes?.map((item) => ({
                  text: Str.from(item.text).initCap,
                  value: item.value,
                })) ?? []
              }
              {...monitoringTypeBinder}
            />
            <Selector.Default
              placeholder="Fonte"
              options={
                types?.map((item) => ({
                  text: Str.from(item.text).initCap,
                  value: item.value,
                })) ?? []
              }
              {...typeBinder}
            />
            <Button.Root $variant="primary" onClick={applyFilters} $loading={loadingReports}>
              <Button.Text value="Filtrar" />
            </Button.Root>
          </FilterGroupLineStyled>
        </InvisibleArea>
      </FilterContainer>
    </FilterGroup>
  )
}
